import * as React from 'react';

export const EditFeed = React.lazy(() => import('./EditFeed'));
